export enum CategoryGroup {
	Products = "Products",
	ProductionAndServices = "ProductionAndServices",
}
